export enum SurveyItemType {
    WEEK_DAYS_RANGE = 'weekDaysRange',
    EVENT_SELECTION = 'eventSelection',
    ASSIGNED_INSTITUTIONS_SELECTION = 'assignedInstitutionsSelection',
}

export namespace SurveyItemType {
    type Data = {
        text: string;
    }

    export const Record: Record<SurveyItemType, Data> = {
        [SurveyItemType.WEEK_DAYS_RANGE]: {
            text: 'Auswahl von Wochentagen',
        },
        [SurveyItemType.EVENT_SELECTION]: {
            text: 'Auswahl von Terminen',
        },
        [SurveyItemType.ASSIGNED_INSTITUTIONS_SELECTION]: {
            text: 'Auswahl zugeteilter Standorte',
        },
    }
}
